import {type ComputedRef, reactive, type Ref, ref} from "vue";
import type {AgendaPart} from "@t/fd/layout/Agenda";
import type {View} from "@t/agenda/View";
import {isAgenda, ItemsGrid} from "@t/fd/layout/Items.ts";

export type LoadState = "ready" | "loading" | "loaded" | "error";

export interface DataLoaderBase {
    state: Ref<LoadState>;
    /** Size of loaded page, <= 0 no limit */
    page: Ref<number>;
    /** Index of the first loaded record */
    position: Ref<number>;
    paused: Ref<boolean>;
    view: View;
    errorMessage: Ref<string>;
}

export interface DataLoader extends DataLoaderBase {
    data: ComputedRef<any[]>;
    total: ComputedRef<number>;
}

export function useLoader(ag:ItemsGrid):DataLoaderBase {
    const state = ref<LoadState>("ready");
    const page = ref<number>(isAgenda(ag) && ag.page ? ag.page : 0);   // no limit
    const position = ref<number>(0);
    const view = reactive<View>({ ...ag.view });
    const errorMessage = ref<string>("");
    const paused = ref<boolean>(isAgenda(ag) ? !!ag.lazyLoad : false);

    return {
        state,
        page,
        position,
        paused,
        view,
        errorMessage
    }
}

// export type DataReceiver = (data:AgendaData<any>) => void;
// export type ErrorReceiver = (reason:any) => void;
//
//
// export interface DataLoaderOptions {
//     onData?: DataReceiver;
//     onError?: ErrorReceiver;
//     onStateChange?: (state:LoadState) => void;
//     sort?: SortColumn[];
//     filter?: Filter;
//     viewProps?: ViewProps;
// }
//
// /**
//  * All data loaders must inherit from this abstract class
//  */
// export class DataLoader {
//     sort: SortColumn[];
//     filter: Filter | null;
//     props: ViewProps;
//     state: LoadState;
//     error: any;
//     data: any[];
//     private onData: DataReceiver | undefined;
//     private onError: ErrorReceiver | undefined;
//     private onStateChange: ((state: LoadState) => void) | undefined;
//
//     constructor(options: DataLoaderOptions) {
//         this.onData = options.onData;
//         this.onError = options.onError;
//         this.onStateChange = options.onStateChange;
//         this.sort = options.sort || [];
//         this.filter = options.filter || null;
//         this.props = options.viewProps || {};
//         this.state = "ready";
//         this.error = null;
//         this.data = [];
//     }
//
//     async query():Promise<any[]> {
//         return [];
//     }
//
//     private setState(s: LoadState) {
//         if (s !== this.state) {
//             this.state = s;
//             if (this.onStateChange) this.onStateChange(s);
//         }
//     }
//
//     /**
//      * @param start index of the first record retrieved (it is zero based)
//      * @param limit maximum number of records returned (may be hard cap applied if the number is too big), must be >= 1
//      */
//     async load(start: number, limit: number) {
//         this.setState("loading");
//         try {
//             this.data = await this.query();
//             this.setState("loaded");
//
//         } catch (ex) {
//             this.setState("error");
//             this.error = ex;
//         }
//     }
//
//     /**
//      * Return true if this loader supports sorting
//      */
//     supportSorting() {
//         return false;
//     }
//
//     withSort(sort: SortColumn[]) {
//         this.sort = sort;
//         return this;
//     }
//
//     /**
//      * Returns true if filter can be changed
//      */
//     supportsFiltering() {
//         return false;
//     }
//
//     withFilter(filter: Filter) {
//         this.filter = filter;
//         return this;
//     }
//
//     withProp(key: string, value: string) {
//         this.props[key] = value;
//     }
// }
